/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDiscountSplash
 */
export interface IDiscountSplash {
    /**
     * 
     * @type {string}
     * @memberof IDiscountSplash
     */
    readonly label?: string;
    /**
     * 
     * @type {number}
     * @memberof IDiscountSplash
     */
    readonly amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IDiscountSplash
     */
    currency?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IDiscountSplash
     */
    readonly isPercentage?: boolean;
}

/**
 * Check if a given object implements the IDiscountSplash interface.
 */
export function instanceOfIDiscountSplash(value: object): boolean {
    return true;
}

export function IDiscountSplashFromJSON(json: any): IDiscountSplash {
    return IDiscountSplashFromJSONTyped(json, false);
}

export function IDiscountSplashFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDiscountSplash {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'isPercentage': json['isPercentage'] == null ? undefined : json['isPercentage'],
    };
}

export function IDiscountSplashToJSON(value?: Omit<IDiscountSplash, 'label'|'amount'|'isPercentage'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currency': value['currency'],
    };
}

